import React from 'react';
import { Tooltip } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import {useMessageStore} from "../../../stores/messageStore";

interface AccountNumberRenderProps {
  text: string;
  record: {
    accountName: string;
    accountBank: string;
  };
}

const AccountNumberRender : React.FC<AccountNumberRenderProps> = ({ text, record }) => {
  return (
      <div style={{display: 'flex', alignItems: 'center'}}>
      <span>
        <div>{text}</div>
        <div>{record.accountName} / {record.accountBank}</div>
      </span>
          <Tooltip title="복사">
              <CopyOutlined
                  style={{cursor: 'pointer', marginLeft: 12}}
                  onClick={() => {
                      const copyText = `${record.accountBank} ${text}`;
                      useMessageStore.setState({
                          isShow: true,
                          type: 'success',
                          content: `복사 완료: ${copyText}`,
                      });
                      navigator.clipboard.writeText(copyText);
                  }}
              />
          </Tooltip>
      </div>
  )
}

export default AccountNumberRender;
